<template>
    <!-- Empty template, because toast message is generated on demand via instance injection by this.$bvToast -->
    <div />
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: { ...mapGetters(['getStatusMessages']) },

        methods: {
            /**
             * Show a toast message
             * @param {object} input, object with option fields
             */
            $_showToast(input) {
                const data = input || {};
                const toastIcon = this.$_getToastIcon(data.variant);
                const closeButton = data.noCloseButton === true || !data.title ? (!data.omitCloseButton && this.$_createCloseBtn()) : null;
                const message = [toastIcon, this.$_createMessage(data.message), closeButton];
                this.$root.$bvToast.toast(message, {
                    title: data.title,
                    variant: data.variant || 'info',
                    autoHideDelay: data.autoHideDelay || 5000,
                    noAutoHide: data.noAutoHide || false,
                    solid: true,
                    appendToast: data.appendToast || false,
                    noCloseButton: data.noCloseButton || !data.title || false,
                    toaster: 'b-toaster-top-center',
                    noFade: true
                });
            },

            /**
             * Returns appropriate icon based on choosen variant
             * @param variant
             */
            $_getToastIcon(variant) {
                const element = this.$createElement;

                switch (variant) {
                    case 'success':
                        return element('em', { 'class': 'fas fa-check' });
                    case 'warning':
                        return element('em', { 'class': 'fas fa-exclamation-triangle' });
                    case 'danger':
                        return element('em', { 'class': 'fas fa-exclamation-circle' });
                    default:
                        return element('em', { 'class': 'fas fa-info-circle' });
                }
            },

            /*
             * Creates a close button element in order to close the toast
             */
            $_createCloseBtn() {
                return this.$createElement('button',
                                           {
                                               class: ['close'],
                                               domProps: { innerHTML: '&times;' },
                                               on: { click: this.$_closeBtnClickHandler }
                                           });
            },

            /*
             * Hides the current toast element
             */
            $_closeBtnClickHandler() {
                this.$root.$bvToast.hide();
            },

            /*
             * Creates a p element needed for the message in toaster body
             * @param message
             */
            $_createMessage(message) {
                return this.$createElement('p', { domProps: { innerHTML: message } });
            },

            /*
             * Shows every message in array
             * @param {Array} messages - Messages array
             */
            $_showMessages(messages) {
                if (messages.length > 0) {
                    messages.forEach(message => {
                        this.$_showToast(message);
                        this.$store.commit('REMOVE_STATUS_MESSAGE');
                    });
                }
            },
        },

        watch: {
            getStatusMessages(newValue) {
                this.$_showMessages(newValue);
            }
        }
    };
</script>
